import { RootState } from 'typesafe-actions'

const root = (state: RootState) => state.convo.sidebar.sidebar

export const detailsSidebarVisible = (state: RootState): boolean =>
  root(state).detailsSidebarVisible

export const detailsSidebarHidden = (state: RootState): boolean =>
  !root(state).detailsSidebarVisible

export const keyboardShortcutsSidebarVisible = (state: RootState): boolean =>
  root(state).keyboardShortcutsSidebarVisible

export const keyboardShortcutsSidebarHidden = (state: RootState): boolean =>
  !root(state).keyboardShortcutsSidebarVisible

export const conversationLogsSidebarVisible = (state: RootState): boolean =>
  root(state).conversationLogsSidebarVisible

export const conversationLogsSidebarHidden = (state: RootState): boolean =>
  !root(state).conversationLogsSidebarVisible

export const routingLogsSidebarVisible = (state: RootState): boolean =>
  root(state).routingLogsSidebarVisible

export const routingLogsSidebarHidden = (state: RootState): boolean =>
  !root(state).routingLogsSidebarVisible

export const routingAuditLogSidebarVisible = (state: RootState): boolean =>
  root(state).routingAuditLogSidebarVisible

export const routingAuditLogSidebarHidden = (state: RootState): boolean =>
  !root(state).routingAuditLogSidebarVisible

export const sidebarSettings = (state: RootState): Record<string, boolean> => root(state)
